export class ArtworkOrder {
  constructor(public id: number, public order: number) {
  }
}
